import Layout from "../../components/layouts/Content";
import BlogProfile from "./BlogProfile";

const BlogPage = () => {
	return (
		<Layout>
			<BlogProfile />
		</Layout>
	);
};

export default BlogPage;
